import {addEventCompareConflicts} from '../helpers/sport/betslip';
import Zergling from '../helpers/zergling';

//DUPLICATE CODE from terminalSpecific
export const bookIdCheck = (data) => {
    const command = (selections, games) => ({
        source: "betting",
        what: {
            sport: ['id', 'alias'],
            region: ['id'],
            competition: ['id'],
            game: [],
            market: [],
            event: ["id", "order", "name", "price", "type", "base"]
        },
        where: {
            game: { id: { "@in": games } },
            event: { id: { "@in": selections } }
        }
    });
    return async (store) => {
        const eventIds = data.data.selectionIds.map(item => item);
        const matchIds = data.data.MatchIds.map(item => item);
        const fullselectionsTree = (await Zergling.get(command(eventIds, matchIds))).data;
        Object.keys(fullselectionsTree.sport).filter(item => Object.prototype.hasOwnProperty.call(fullselectionsTree.sport, item)).map(item => {
            const sport = fullselectionsTree.sport[item];
            Object.keys(sport.region).filter(item => Object.prototype.hasOwnProperty.call(sport.region, item)).map(item => {
                const region = sport.region[item];
                Object.keys(region.competition).filter(item => Object.prototype.hasOwnProperty.call(region.competition, item)).map(item => {
                    const competition = region.competition[item];
                    Object.keys(competition.game).filter(item => Object.prototype.hasOwnProperty.call(competition.game, item)).map(item => {
                        const game = competition.game[item];
                        Object.keys(game.market).filter(item => Object.prototype.hasOwnProperty.call(game.market, item)).map(item => {
                            const market = game.market[item];
                            Object.keys(market.event).filter(item => Object.prototype.hasOwnProperty.call(market.event, item)).map(item => {
                                const event = market.event[item];
                                store.dispatch(addEventCompareConflicts({
                                    ...game,
                                    alias: sport.alias,
                                    regionId: region.id,
                                    competitionId: competition.id
                                }, market, event, event.id));
                            });
                        });
                    });
                });
            });
        });
    };
}

